export default {"src":"/_next/static/media/card3.f2840641.svg","height":239,"width":388,"blurWidth":0,"blurHeight":0};